import React from 'react';
import { HeaderProps, HeaderItemProps, HeaderSubItemProps } from './types';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import Styles from './HeaderMobile.module.less';
import CommonStyles from './Common.module.less';
import { classes, hasValidChildren, useToggler } from '../../../lib';
import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Collapse } from '../Collapse';
import { LpLink } from '../LpLink';

export const HeaderSubItem = ({
    icon,
    title,
    href,
}: Omit<HeaderSubItemProps, 'children'>): JSX.Element => {
    return (
        <LpLink
            to={href}
            className={classes('horizontal left-middle g8', Styles.subItem)}>
            {icon}
            <span className="secondary-text">{title}</span>
        </LpLink>
    );
};

export const HeaderItem = ({
    children,
    href,
    text,
}: HeaderItemProps): JSX.Element => {
    const hasChildren = children && hasValidChildren(children);
    return hasChildren ? (
        <Collapse className={Styles.item}>
            <Collapse.Panel key={text} header={text}>
                <div className="vertical stretch-top g16">{children}</div>
            </Collapse.Panel>
        </Collapse>
    ) : (
        <LpLink to={href} className={Styles.item}>
            {text}
        </LpLink>
    );
};

export const Header = ({
    logo,
    loginButton,
    signupButton,
    children,
    showSignupButton,
    hideMenu,
    hideButtons,
}: HeaderProps): JSX.Element => {
    const [menu, toggleMenu] = useToggler();
    return (
        <header
            className={classes(
                'd-hidden horizontal between-middle px16',
                CommonStyles.header
            )}>
            {logo}
            <div className="horizontal between-middle g32">
                {!hideButtons && showSignupButton && signupButton}
                {!hideMenu && (
                    <FontAwesomeIcon
                        onClick={toggleMenu}
                        className="pointer"
                        icon={menu ? faTimes : faBars}
                    />
                )}
            </div>
            {menu && (
                <div
                    className={classes(
                        Styles.menuContainer,
                        'vertical stretch-top g16 p16'
                    )}>
                    <div
                        className={classes(
                            Styles.menuItems,
                            'vertical stretch-top'
                        )}>
                        {children}
                    </div>
                    <div
                        className={classes(
                            Styles.buttons,
                            'horizontal stretch-middle g8'
                        )}>
                        {loginButton}
                        {signupButton}
                    </div>
                </div>
            )}
        </header>
    );
};
